import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Admin, Resource } from "react-admin";

import authProvider from "./providers/authProvider";
import fileDataProvider from "./providers/fileDataProvider";
import Login from "./components/Login/Login";
import ContentList from "./components/Content/ContentList";
import { ContentCreate } from "./components/Content/ContentCreate";
import ContentEdit from "./components/Content/ContentEdit";
import {
  ContentItemCreate,
  ContentItemEdit,
} from "./components/ContentItem/ContentItemCreate";
import { TopicCreate } from "./components/Topic/TopicCreate";
import TopicEdit from "./components/Topic/TopicEdit";
import TopicList from "./components/Topic/TopicList";
import ContentTagList from "./components/ContentTag/ContentTagList";
import {
  ContentTagCreate,
  ContentTagEdit,
} from "./components/ContentTag/ContentTagCreate";
import resources from "./constants/resources";
import { appTheme } from "./styles/theme";

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <Admin
        loginPage={Login}
        authProvider={authProvider}
        dataProvider={fileDataProvider}
      >
        <Resource
          name={resources.TOPIC.url}
          list={TopicList}
          create={TopicCreate}
          edit={TopicEdit}
          options={{ label: resources.TOPIC.label }}
        />
        <Resource
          name={resources.CONTENT.url}
          list={ContentList}
          create={ContentCreate}
          edit={ContentEdit}
          show={ContentEdit}
          options={{ label: resources.CONTENT.label }}
        />
        <Resource
          name={resources.CONTENT_ITEMS.url}
          create={ContentItemCreate}
          edit={ContentItemEdit}
          options={{ label: resources.CONTENT_ITEMS.label }}
        />
        <Resource
          name={resources.CONTENT_TAGS.url}
          list={ContentTagList}
          create={ContentTagCreate}
          edit={ContentTagEdit}
          options={{ label: resources.CONTENT_TAGS.label }}
        />
      </Admin>
    </ThemeProvider>
  );
}

export default App;
